import {Socket} from './socket'

angular.module('app').factory('socket', ['$rootScope', $rootScope => new Socket($rootScope)])
